import { render, staticRenderFns } from "./RecordFeeSummary.vue?vue&type=template&id=e1b2ad2a"
import script from "./RecordFeeSummary.vue?vue&type=script&lang=js"
export * from "./RecordFeeSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports